import React from 'react';
import LocationPageTemplate from './LocationPageTemplate';

export default function WyliePage() {
  return (
    <LocationPageTemplate
      city="Wylie"
      slug="wylie"
      neighborhoods="From Lake Lavon shorelines to Bozman Farm and Inspiration, we service Wylie irrigation systems daily."
      localCopy={[
        "Wylie's mix of established 1980s neighborhoods and brand-new construction along Highway 78 means we see everything — from corroded valves on original lines to modern smart Rachio controllers needing fresh WiFi setup after a router upgrade.",
        "Proximity to Lake Lavon means many Wylie systems pull harder water that mineralizes nozzles, valve seats, and pressure regulators faster than other cities. Our trucks carry every common replacement part on board so most repairs happen on the first visit.",
        "Wylie requires a backflow preventer on every irrigation system. AAA Irrigation installs the backflow, schedules the annual certification testing, and files the paperwork with the City of Wylie. One call covers installation and compliance.",
      ]}
      reviewQuote="John fixed three broken heads, a leaking valve, and recalibrated our controller in one visit. Honest about what needed replacing and what could wait. Great experience."
      reviewAuthor="Amanda S. — Wylie, TX"
    />
  );
}
